const PENDING_KEY = "socialVerificationPending";
const RESULT_KEY = "socialVerificationResult";

export const savePendingSocialVerification = (value) => {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(value || {}));
};

export const getPendingSocialVerification = () => {
    try {
        return JSON.parse(sessionStorage.getItem(PENDING_KEY) || "null");
    } catch {
        return null;
    }
};

export const clearPendingSocialVerification = () => {
    sessionStorage.removeItem(PENDING_KEY);
};

export const saveSocialVerificationResult = (value) => {
    sessionStorage.setItem(RESULT_KEY, JSON.stringify(value || {}));
};

export const consumeSocialVerificationResult = () => {
    try {
        const raw = sessionStorage.getItem(RESULT_KEY);
        sessionStorage.removeItem(RESULT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        sessionStorage.removeItem(RESULT_KEY);
        return null;
    }
};
